import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const STORAGE_KEY = 'pb_cookie_consent';

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      if (!localStorage.getItem(STORAGE_KEY)) setVisible(true);
    } catch (e) {
      setVisible(true);
    }
  }, []);

  const accept = () => {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify({ accepted: true, ts: Date.now() })); } catch(e) {}
    setVisible(false);
  };

  const reject = () => {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify({ accepted: false, ts: Date.now() })); } catch(e) {}
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div role="dialog" aria-label="Consimtamant cookies" style={{
      position: 'fixed',
      bottom: 16,
      left: 16,
      right: 16,
      maxWidth: 720,
      margin: '0 auto',
      background: '#0A1428',
      color: '#fff',
      padding: '20px 24px',
      borderRadius: 12,
      boxShadow: '0 24px 56px rgba(0,0,0,0.35)',
      zIndex: 9999,
      display: 'flex',
      flexDirection: 'column',
      gap: 16,
    }}>
      <div style={{ fontFamily: 'Inter, system-ui, sans-serif', fontSize: 14, lineHeight: 1.6, color: '#E5E7EB' }}>
        Folosim cookie-uri esentiale pentru autentificare si functionarea platformei. Nu folosim cookie-uri de marketing sau urmarire fara consimtamantul tau. Detalii in{' '}
        <Link to="/cookies" style={{ color: '#D4AF37', textDecoration: 'underline' }}>Politica de cookies</Link>.
      </div>
      <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
        <button
          onClick={accept}
          style={{
            padding: '10px 22px',
            background: '#D4AF37',
            color: '#0A1428',
            border: 'none',
            borderRadius: 6,
            fontFamily: 'DM Mono, monospace',
            fontSize: 11,
            letterSpacing: 2,
            textTransform: 'uppercase',
            cursor: 'pointer',
            fontWeight: 700,
          }}
        >
          Accept toate
        </button>
        <button
          onClick={reject}
          style={{
            padding: '10px 22px',
            background: 'transparent',
            color: '#fff',
            border: '1px solid rgba(255,255,255,0.4)',
            borderRadius: 6,
            fontFamily: 'DM Mono, monospace',
            fontSize: 11,
            letterSpacing: 2,
            textTransform: 'uppercase',
            cursor: 'pointer',
          }}
        >
          Doar esentiale
        </button>
      </div>
    </div>
  );
}
